import { Box } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { RegimeSearchBreadcrumb } from "routes/regime/plugins/regime-search/regime-search-breadcrumb.js"

export function RegimeSearchGroup({ breadcrumbs, onNavigate, children }) {
    return (
        <li>
            <If value={breadcrumbs.length > 0}>
                <Box
                    data-cy="regime-search-group-header"
                    onMouseDown={keepInputFocus}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.75,
                        px: 2,
                        py: 1.5,
                        bgcolor: "background.neutral",
                        overflow: "hidden",
                        position: "sticky",
                        top: -8,
                        zIndex: 1,
                    }}
                >
                    <Repeat list={breadcrumbs} item={<RegimeSearchBreadcrumb onNavigate={onNavigate} />} />
                </Box>
            </If>
            <Box component="ul" sx={{ p: 0 }}>
                {children}
            </Box>
        </li>
    )

    function keepInputFocus(event) {
        event.preventDefault()
    }
}
